import React from "react"
import { Chip, IconButton, FontIcon } from "material-ui"
import autobind from "class-autobind"
import AddAccountPositionDialogForChip from "./AddAccountPositionDialogForChip"
import { IPosition } from "../../../models"
import AccountStore from "../../../stores/AccountStore"

interface IProps {
    readonly: boolean
    error: string
    label: string
    selectedPositionIds: string[]
    handleChange(selectedPositions: IPosition[]): void
}
interface IState {
    selectedPositions: IPosition[]
    openAddSelectAccountPositionDialog: boolean
}

export default class AccountPositionChips extends React.Component<IProps, IState> {
    private accountPositionDefinitions: IPosition[]
    constructor(props: IProps) {
        super(props)
        this.accountPositionDefinitions = AccountStore.getCurrentAccount().PositionDefinitions.filter(i => i.Active)
        this.state = {
            selectedPositions: this.accountPositionDefinitions.filter(i => this.props.selectedPositionIds.includes(i.BasePositionId)),
            openAddSelectAccountPositionDialog: false,
        }
        autobind(this)
    }

    render() {
        const candidatePositions = this.accountPositionDefinitions.filter(i => !this.state.selectedPositions.find(e => i.BasePositionId === e.BasePositionId))
        return (
            <div>
                <div>
                    <span>{this.props.label}</span>
                    <span style={{ color: "rgb(244, 67, 54)", fontSize: 12, marginLeft: 15 }}>{this.props.error}</span>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {this.state.selectedPositions.map(position =>
                        <Chip
                            key={position.Id}
                            style={{ margin: 5, cursor: "pointer" }}
                            onRequestDelete={this.props.readonly ?
                                null :
                                () => {
                                    const selectedPositions = this.state.selectedPositions.filter(i => i.BasePositionId !== position.BasePositionId)
                                    this.setState({ selectedPositions })
                                    this.props.handleChange(selectedPositions)
                                }}
                        >
                            {position.Name}
                        </Chip>
                    )}
                    {!this.props.readonly && (candidatePositions.length > 0 || !this.state.selectedPositions.length) &&
                        <IconButton
                            style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
                            onTouchTap={() => this.setState({ openAddSelectAccountPositionDialog: true })}
                        >
                            <FontIcon className="fa fa-plus-circle" />
                        </IconButton>
                    }
                </div>
                {this.state.openAddSelectAccountPositionDialog &&
                    <AddAccountPositionDialogForChip
                        candidatePositions={candidatePositions}
                        handleClose={() => this.setState({ openAddSelectAccountPositionDialog: false })}
                        handleUpdate={positions => {
                            let selectedPositions = this.state.selectedPositions
                            positions.forEach(i => {
                                !selectedPositions.find(e => e.Id === i.Id) &&
                                    selectedPositions.push(i)
                            })
                            this.setState({ selectedPositions, openAddSelectAccountPositionDialog: false })
                            this.props.handleChange(selectedPositions)
                        }}
                    />
                }
            </div>
        )
    }
}